const toText = (value) => (value == null ? '' : String(value).trim());

const normalizeEmployee = (request) => {
  return (
    toText(request?.user?.name) ||
    toText(request?.employee_name) ||
    toText(request?.user_name) ||
    toText(request?.user_id) ||
    '-'
  );
};

const normalizeLeaveType = (request) => {
  return toText(request?.leave_type) || toText(request?.title) || toText(request?.type) || toText(request?.request_type) || '-';
};

const normalizeStatus = (value) => {
  return toText(value) || '-';
};

export const normalizeRecentRequestRows = (rows, formatDate) => {
  const list = Array.isArray(rows) ? rows : [];

  return list.map((request, index) => {
    const sourceId = request?.id ?? `row-${index}`;
    const moduleKey = toText(request?.module) || toText(request?.request_type) || 'request';

    return {
      ...request,
      id: `${moduleKey}-${sourceId}-${index}`,
      sourceId,
      employeeDisplay: normalizeEmployee(request),
      leaveTypeDisplay: normalizeLeaveType(request),
      startDateDisplay: formatDate(request?.start_date || request?.date_from),
      endDateDisplay: formatDate(request?.end_date || request?.date_to),
      statusDisplay: normalizeStatus(request?.status_label || request?.status),
      hrStatusDisplay: normalizeStatus(request?.hr_status),
    };
  });
};

export const filterRecentRequestRows = (rows, searchTerm) => {
  const list = Array.isArray(rows) ? rows : [];
  const term = toText(searchTerm).toLowerCase();

  if (!term) return list;

  return list.filter((row) =>
    `${toText(row?.employeeDisplay)} ${toText(row?.leaveTypeDisplay)}`.toLowerCase().includes(term)
  );
};
